module.exports = __webpack_public_path__ + "static/media/group-logo-white.8a288011.svg";